import { RouteConfig } from 'vue-router';

import PageBillings from './PageBillings.vue';

export default {
  path: 'list',
  name: 'billings',
  component: PageBillings,
  meta: {
    title: 'Faturas',
  },
} as RouteConfig;
